<template>
	<AppFilter @apply="onFilter" v-model="filters" :isPadding="true" ref="appFilter"/>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		name:"productAdvanceFilter",
		props: {

		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {

		},
		computed: {
			productAdvanceFilter:{
				set(val){
					this.$store.commit('updateProductsFilter',val)
				},
				get(){
					return this.$store.state.productAdvanceFilter
				}
			}
		},
		async mounted() {


			this.getData()

		},
		methods: {
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
					{
							filters[input[i].name] = input[i].value;

					}
				}
				filters.advanceSearchType = "product";
				let payload = {};

				if(filters["category"]){
					if(filters["category"].name == 'All'){
						payload.category = ''
					}
					else if(filters["category"].name == 'Empty/NULL'){
						payload.category = 'empty/null data'
					}
					else{
						payload.category = filters["category"].name
					}
				}
				if(filters["style"]){
					if(filters["style"].name == 'All'){
						payload.style = '';
					}
					else if(filters["style"].name == 'Empty/NULL'){
						payload.style = 'empty/null data'
					}
					else{
						payload.style = filters["style"].name
					}
				}

				this.$store.state.currentPageNumber = 1;
				this.$store.commit("product/setadvanceFilterProduct", payload);
				this.$emit("getFilterProducts");
			},
			getData(){
			},
			setFilters() {
				this.filters = [];
				this.filters = [
                    {
						name: "break",
						type: "break"
					},
					{
						name: "category",
						label: "Category",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.category_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					// {
					// 	name: "active_type",
					// 	label: "Active",
					// 	type: "select",
					// 	placeholder: "Select",
					// 	value: [],
					// 	enabled: false,
					// 	values: [
					// 		{
					// 			name: "Active",
					// 			code: true
					// 		},
					// 		{
					// 			name: "Non Active",
					// 			code: false
					// 		 }
					// 	],
					// 	padding:true
					// },
					// {
					// 	name: "break",
					// 	type: "break"
					// },
					{
						name: "style",
						label: "Style",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.style_tag_list,
						padding:true
					},
					{
						name: "break",
						type: "break"
					}

				];
				this.productAdvanceFilter = JSON.parse(JSON.stringify(this.filters))
			}

		},
		data() {
			return {
				filters: [],
				list : [],
				category_tags_List:[],
				style_tag_list:[],
				// copyRetainFilter:[]
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
